import { createFileRoute } from "@tanstack/react-router";
import UserInfo from "@/features/assessments/pages/user-info/UserInfo";

export const Route = createFileRoute("/$locale/$partner/_results/user-info")({
	component: UserInfo,
});
